import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type TInitState = {
  debug: {
    rotation: {
      x: number;
      y: number;
      z: number;
    };
  };
};

const initialState: TInitState = {
  debug: {
    rotation: {
      x: 0,
      y: 0,
      z: 0,
    },
  },
};

/**
 * started to move rightPanel state to this reducer
 * once done rename to rightPanel.slice.ts
 */
const rightPanel2Slice = createSlice({
  name: "rightPanel2",
  initialState,
  reducers: {
    setDebug: (state, action: PayloadAction<TInitState["debug"]>) => ({
      ...state,
      debug: {
        ...state.debug,
        ...action.payload,
      },
    }),
  },
});

export const rootPanel2Actions = rightPanel2Slice.actions;
export default rightPanel2Slice;
